module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxyZWN0IHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgeD0iMTcxLjUiIHk9IjU0LjUiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjOTc5Nzk3IiByeD0iNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE3MSAtNTQpIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-checkmark.svg
// module id = 2728
// module chunks = 0